module.exports = __webpack_public_path__ + "media/images/icons/icon-twitter-3f59c18fd78a5477136e61fc60f332e2.svg";